import ErrorPage from '../pages/ErrorPage';
import { ErrorBoundary } from 'react-error-boundary';
import { captureError } from './sentry';
import PropTypes from 'prop-types';

export default function ReactErrorBoundary(props) {
	return (
		<ErrorBoundary
			FallbackComponent={ErrorPage}
			onError={(error, errorInfo) => {
				// log the error
				console.log('Error caught!');
				console.error(error);
				console.error(errorInfo);

				// Send error to Sentry
				captureError(error, {
					errorBoundary: true,
					errorInfo,
					timestamp: new Date().toISOString(),
				});
			}}
			onReset={() => {
				// reloading the page to restore the initial state
				// of the current page
				console.log('reloading the page...');
				window.location.reload();

				// other reset logic...
			}}
		>
			{props.children}
		</ErrorBoundary>
	);
}

ReactErrorBoundary.propTypes = {
	children: PropTypes.node.isRequired,
};
